package com.narbase.letsgo.web.models

import com.narbase.letsgo.dto.EnumDtoName

enum class RoutingProvider(dtoName: String? = null) : EnumDtoName {
    Google,
    OSRM
    ;

    override val dtoName = dtoName ?: this.name
}